module.exports = __webpack_public_path__ + "img/smsicon.eb8d8ab8.png";